import { useUser } from '@liveblocks/react'

import { StringNameAvatar } from '@/components/lemmala-design-system/avatar'

type SuggestionUserProps = {
  userId: string
}

export const SuggestionUser = ({ userId }: SuggestionUserProps) => {
  const { user } = useUser(userId)
  const name = user?.name ?? userId

  return (
    <>
      <StringNameAvatar
        name={name}
        imageSrc={user?.avatar}
        type={user?.avatar ? 'image' : 'initials'}
        size='small'
      />
      <span className='min-w-0 truncate' title={name}>
        {name}
      </span>
    </>
  )
}
